module.exports = __webpack_public_path__ + "278460995b465b66577269e5e59c73ae.png";